<div class="footerPageTop" id="js-pageTop" style="display: block;">
    <a href="#"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_pagetop.svg?v=202010280237" alt=""></a></div>
<!-- /.footerPageTop -->
<div class="footerMain">
    <div class="footerMain_logo"><a href="https://jp.visitozu.com/"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/pic_logo.svg?v=202010280237" alt="おおず 四国愛媛・大洲"></a></div>

    <div class="footerMain_inner">

        <div class="footerMain_item">
            <dl class="footerMain_list">
                <dt><a href="https://jp.visitozu.com/">HOME</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="about_ozu" href="https://jp.visitozu.com/about/">大洲について</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="inside_ozu" href="https://jp.visitozu.com/story/">大洲にあるもの</a></dt>
                <dd>
                    <ul class="footerMain_slist">
                        <li><a data-lang="water_town" href="https://jp.visitozu.com/story/nature/">水郷の自然</a></li>
                        <li><a data-lang="traditional_culture" href="https://jp.visitozu.com/story/history/">伝統文化・歴史</a></li>
                        <li><a data-lang="castle_town" href="https://jp.visitozu.com/story/gourmet/">城下町の美味</a></li>
                    </ul>
                </dd>
            </dl>
        </div>

        <div class="footerMain_item">
            <dl class="footerMain_list">
                <dt><a data-lang="special_feature" href="https://jp.visitozu.com/feature/">特集</a></dt>
                <dd>
                    <ul class="footerMain_slist">
                        <li><a data-lang="ozu_story" href="https://jp.visitozu.com/archives/feature_cat/cat01">大洲の徒然話</a></li>
                        <li><a data-lang="travel_story" href="https://jp.visitozu.com/archives/feature_cat/cat02">旅のお話</a></li>
                        <li><a data-lang="food_story" href="https://jp.visitozu.com/archives/feature_cat/cat03">食のお話</a></li>
                        <li><a data-lang="inn_story" href="https://jp.visitozu.com/archives/feature_cat/cat05">宿のお話</a></li>                        </ul>
                </dd>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="ozu_spending" href="https://jp.visitozu.com/experience/">大洲での過ごし方</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="ozu_inn" href="https://jp.visitozu.com/inn/">大洲のお宿</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="event_announcement" href="https://jp.visitozu.com/blog/">出来事とお知らせ</a></dt>
            </dl>
        </div>

        <div class="footerMain_item">
            <dl class="footerMain_list">
                <dt><a data-lang="highlight" href="https://jp.visitozu.com/highlight/">見どころを探す</a></dt>
                <dd>
                    <ul class="footerMain_slist">
                        <li><a data-lang="entire_city" href="https://jp.visitozu.com/highlight/">市内全域</a></li>
                        <li><a data-lang="ozu" href="https://jp.visitozu.com/archives/highlight_cat/cat01">大洲</a></li>
                        <li><a data-lang="hijikawa" href="https://jp.visitozu.com/archives/highlight_cat/cat02">肱川</a></li>
                        <li><a data-lang="riverside" href="https://jp.visitozu.com/archives/highlight_cat/cat03">河辺</a></li>
                        <li><a data-lang="nagahama" href="https://jp.visitozu.com/archives/highlight_cat/cat04">長浜</a></li>                        </ul>
                </dd>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="event" href="https://jp.visitozu.com/eventinfo/">大洲の催し</a></dt>
            </dl>
        </div>

        <div class="footerMain_item">
            <dl class="footerMain_list">
                <dt><a data-lang="ozu_journey" href="https://jp.visitozu.com/access/">大洲への旅路</a></dt>
                <dd>
                    <ul class="footerMain_slist">
                        <li><a data-lang="from_tokyo" href="https://jp.visitozu.com/access/tokyo/">東京からの路</a></li>
                        <li><a data-lang="from_kyoto" href="https://jp.visitozu.com/access/kyoto_osaka/">京都・大阪・神戸からの路</a></li>
                        <li><a data-lang="from_nagoya" href="https://jp.visitozu.com/access/nagoya/">名古屋からの路</a></li>
                        <li><a data-lang="from_hiroshima" href="https://jp.visitozu.com/access/hiroshima/">広島からの路</a></li>
                        <li><a data-lang="from_others" href="https://jp.visitozu.com/access/other/">その他地域からの路</a></li>
                        <li><a data-lang="by_car" href="https://jp.visitozu.com/access/city/">大洲市内・お車でお越しの方</a></li>
                    </ul>
                </dd>
            </dl>

        </div>

        <div class="footerMain_item">
            <dl class="footerMain_list">
                <dt><a data-lang="town_walk" href="http://www.asamoya.com/kairoh/" target="_blank">まち歩き「おおず歴史華回廊」</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="for_agencies" href="https://kita-m.com/" target="_blank">旅行業者様・事業者の方へ</a></dt>
            </dl>
            <dl class="footerMain_list">
                <dt><a data-lang="ozu_souvenirs" href="https://jp.visitozu.com/tax_payment/">大洲の土産もの</a></dt>
                <dd>
                    <ul class="footerMain_slist">
                        <li><a data-lang="external_link" href="https://jp.visitozu.com/guide/link/">外部リンク</a></li>
                        <li><a data-lang="inquiry" href="https://jp.visitozu.com/guide/contact/">お問い合わせ</a></li>
                        <li><a data-lang="site_map" href="https://jp.visitozu.com/guide/sitemap/">サイトマップ</a></li>
                    </ul>
                </dd>
            </dl>

        </div>
    </div>
</div>
<!-- /.footerMain -->


<div class="footerBtm">
    <div class="footerBtm_left">
        <ul>
            <li><a data-lang="using_site" href="https://jp.visitozu.com/privacy/">このサイトのご利用にあたって</a></li>
            <li><a data-lang="privacy_policy" href="https://jp.visitozu.com/guide/privacy/">プライバシーポリシー</a></li>
            <!-- <li><a data-lang="" href="https://jp.visitozu.com/contact/">お問い合わせ</a></li> -->
        </ul>
    </div>

    <ul class="footerBtm_sns">
        <li><a data-lang="" href="https://www.instagram.com/visit_ozu/" target="_blank"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer_01.svg?v=202010280237" alt=""></a></li>
        <li><a data-lang="" href="https://www.facebook.com/visitozu" target="_blank"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer_03.svg?v=202010280237" alt=""></a></li>
    </ul>


    <div class="footerBtm_right">
        <div class="footerBtm_logo"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer.svg?v=202010280237" alt=""></div>
        <div class="footerBtm_copy">Copyright© KITA MANAGEMENT. All rights reserved.</div>

    </div>



</div>
<!-- /.footerBtm -->

